<template>
  <div style="height: 100%">

    <div class="site_homePage_title" style="margin-top: -8px">
      <div style="width: 100%;height: 80%; display: flex;flex-direction: row;align-items: center;justify-content: space-between">
        <div style="background-color: #0a84ff;height: 100%;width: 100%" class="site_homePage_title_inner">
          <div class="varchar_size" >{{'CW制造部'}}</div>
          <div class="varchar_size" >{{'涂装科生产看板'}}</div>
          <div class="varchar_size" >{{this.currentTime}}</div>
        </div>
      </div>
    </div>

    <div class="pageContainer">
      <div class="asideContainer" style="border-right: 4px solid whitesmoke; width: 40%;">
        <div class="size" style="height: 12%;">
          <div class="summary">
            <div class="messageCard" >
              <div class="message" style="width:100%;text-align: center;background-color: rgb(93, 201, 131)">{{'在岗工人'}}</div>
              <h2 style="color: black;font-size: 18px">{{this.tzProductionData.worker_num}}</h2>

            </div>
            <div class="messageCard">
              <div class="message" style="width:100%;text-align: center;background-color: rgb(217, 154, 79)">{{'前处理重量'}}</div>
              <h2 style="color: black;font-size: 18px">{{this.tzProductionData.pretreatment_weight+'KG'}}</h2>
            </div>
            <div class="messageCard">
              <div class="message" style="width:100%;text-align: center;background-color: #d57a0d">{{'前处理面积'}}</div>
              <h2 style="color: black;font-size: 18px">{{this.tzProductionData.pretreatment_area+'㎡'}}</h2>
            </div>
            <div class="messageCard" >
              <div class="message" style="width:100%;text-align: center;background-color: #40a9ff">{{'喷涂重量'}}</div>
              <h2 style="color: black;font-size: 18px">{{this.tzProductionData.spray_weight+'KG'}}</h2>
            </div>
            <div class="messageCard" >
              <div class="message" style="width:100%;text-align: center;background-color: #096dd9">{{'喷涂面积'}}</div>
              <h2 style="color: black;font-size: 18px">{{this.tzProductionData.spray_area+'㎡'}}</h2>
            </div>

          </div>
        </div>
        <div class="size" style="height: 32%;">
          <div class="title">{{'物件生产进度概况'}}</div>
          <el-table ref="table" id="infoTable" :data="scheduleTableData" height="100%" border stripe style="width: 95%;"
                    :header-cell-style="{textAlign: 'center',backgroundColor: '#0a84ff', color: '#ffffff',fontSize: '16px'}"
                    :cell-style="{ textAlign: 'center', width: '100%',color: '#0a84ff',fontSize: '16px',borderBottom: '0.5px #0a84ff solid', borderRight: '0.5px #0a84ff solid'}">
            <el-table-column prop="wujian_id" min-width="240px" label="物件">
            <template v-slot="scope">
              {{scope.row.wujian_id+'-'+scope.row.wujian_short_name}}
            </template>
            </el-table-column>
            <el-table-column label="楼层" min-width="140px">
            <template v-slot="scope">
              {{scope.row.floor+'F'}}
            </template>
            </el-table-column>
            <el-table-column prop="completion_progress" label="生产进度" min-width="160px"/>
          </el-table>
        </div>
        <div class="size" style="height: 46%;border: none">
          <div style="width: 100%;height: 100%;">
            <div style="border-left: 3px solid steelblue;height: 18px;padding-left: 5px;margin-bottom: 5px;margin-left: 5%;display: flex;align-items: center">{{ '技能等级看板' }}</div>
            <div v-loading="userLoading" style="width: 100%; height: 100%; border-width: 1px 0 1px 0; border: whitesmoke solid">
              <div style="height: 24%; display: flex;">
                <div class="level1" style="background-color: #206fd5;">
                  <span>{{"高级"}}</span>
                </div>
                <div class="level1-right">
                  <div v-for="item in gGrade" :key="item.id" class="level2" :style="'height:' + 100/gGrade.length + '%'">
                    <span class="grade">{{item.grade}}</span>
                    <div class="scroll-container">
                      <div class="scroll-content">
                    <div v-for="user in item.gradeUsers" :key="user.id" class="userCard">
                      <div style="width: 33%;height: 100%" class="border-right">
                        <el-image style="width: 100%; height: 100%" :src="user?.headUrl" fit="fill">
                          <template #error>
                            <div class="image-slot">
                              <el-icon><icon-picture /></el-icon>
                            </div>
                          </template>
                        </el-image>
                      </div>
                      <div style="width: 66%;height: 100%">
                        <div class="sizeUser align-center border-bottom border-right">{{user.user_name}}</div>
                        <div class="sizeUser align-center border-top border-bottom border-right">{{user.full_name}}</div>
                        <div class="sizeUser align-center border-right">{{user.post}}</div>
                      </div>
                    </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="height: 35%; display: flex">
                <div class="level1" style="background-color: #e4973d;">
                  <span>{{"中级"}}</span>
                </div>
                <div class="level1-right">
                  <div v-for="item in zGrade" :key="item.id" class="level2" :style="'height:' + 100/zGrade.length + '%'">
                    <span class="grade">{{item.grade}}</span>
                    <div class="scroll-container">
                      <div class="scroll-content">
                    <div v-for="user in item.gradeUsers" :key="user.id" class="userCard">
                      <div style="width: 33%;height: 100%" class="border-right">
                        <el-image style="width: 100%; height: 100%" :src="user?.headUrl" fit="fill">
                          <template #error>
                            <div class="image-slot">
                              <el-icon><icon-picture /></el-icon>
                            </div>
                          </template>
                        </el-image>
                      </div>
                      <div style="width: 66%;height: 100%">
                        <div class="sizeUser align-center border-bottom border-right">{{user.user_name}}</div>
                        <div class="sizeUser align-center border-top border-bottom border-right">{{user.full_name}}</div>
                        <div class="sizeUser align-center border-right">{{user.post}}</div>
                      </div>
                    </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="height: 35%; display: flex">
                <div class="level1" style="background-color: #04cc7c;">
                  <span>{{"初级"}}</span>
                </div>
                <div class="level1-right">
                  <div v-for="item in cGrade" :key="item.id" class="level2" :style="'height:' + 100/cGrade.length + '%'">
                    <span class="grade">{{item.grade}}</span>
                    <div class="scroll-container">
                      <div class="scroll-content">
                    <div v-for="user in item.gradeUsers" :key="user.id" class="userCard">
                      <div style="width: 33%;height: 100%" class="border-right">
                        <el-image style="width: 100%; height: 100%" :src="user?.headUrl" fit="fill">
                          <template #error>
                            <div class="image-slot">
                              <el-icon><icon-picture /></el-icon>
                            </div>
                          </template>
                        </el-image>
                      </div>
                      <div style="width: 66%;height: 100%">
                        <div class="sizeUser align-center border-bottom border-right">{{user.user_name}}</div>
                        <div class="sizeUser align-center border-top border-bottom border-right">{{user.full_name}}</div>
                        <div class="sizeUser align-center border-right">{{user.post}}</div>
                      </div>
                    </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--      //排产-->
      <div class="asideContainer" v-loading="loading"  element-loading-text="数据加载中..." style="border-left: 4px solid whitesmoke; width: 60%;" >
        <div class="size" style="height: 60%;">
          <div style="padding: 0;width:100%;height: 100%;margin-left: 2px;overflow-x: hidden;overflow-y: hidden">
            <div ref="total_height" style="width:100%;height: 100%;overflow-x: hidden;overflow-y: hidden">
              <!--        时间-->
              <div style="height: 100%;width: 100%;overflow-x: auto;overflow-y: hidden">
                <div style="display: flex;text-align: center;">
                  <div v-for="calendar in state.dataList" style="width:100%;" :key="calendar">
                    <div style="margin-left: 3px" :style="calendar.expireTimeClass" class="border color">
                      <div>{{ calendar.time }}</div>
                      <div>{{ calendar.week }}</div>
                    </div>
                  </div>
                </div>
                <!--数据-->
                <div style="height: 100%;overflow-y: auto;overflow-x: hidden;width: 100%;display: flex;" ref="dynamicDiv" class="scrollable-container">
                  <div class="total_style" v-for="item in state.dataList" style="width: 100%;" :key="item">
                    <div v-if="!item.line_bool" :class="!item.line_bool?'prompt data_style1':''" :style="maxHeight">产线未开</div>
                    <div v-if="item.line_bool" class="data_style">
                      <div v-for="lineCnt in item.line_cnt" :key="lineCnt" class="data_style2"
                           :style="item.expireTimeClass">
                        <div class="data_style3">
                          <span v-if="lineCnt.dayShiftCnt == 'powder'" class="data_style4">&nbsp;粉体&nbsp;</span>
                          <span v-if="lineCnt.dayShiftCnt == 'liquid'" class="data_style4">&nbsp;液体&nbsp;</span>
                          <span v-if="lineCnt.dayShiftCnt == 'pretreatment'" class="data_style4">&nbsp;前处理&nbsp;</span>
                          <!--                      <span v-if="lineCnt.nightShiftCnt == 'powder'" class="data_style4_1">&nbsp;粉体&nbsp;</span>-->
                          <!--                      <span v-if="lineCnt.nightShiftCnt == 'liquid'" class="data_style4_1">&nbsp;液体&nbsp;</span>-->
                          <!--                      <span v-if="lineCnt.nightShiftCnt == 'pretreatment'" class="data_style4_1">&nbsp;前处理&nbsp;</span>-->
                        </div>
                        <div v-if="lineCnt.remark != '' && lineCnt.remark != undefined" class="item">
                          <el-row>
                            <el-col :span="24">
                              <span>{{ lineCnt.remark }}</span>
                            </el-col>
                          </el-row>
                        </div>
                        <div>
                          <draggable :style="lineCnt.height" :class="lineCnt.class_line_name" :list="lineCnt.lineData"  ghost-class="ghost" chosen-class="chosenClass" handle=".move" animation="300"
                                     :sort="true" group="group">
                            <template  #item="{ element }">
                              <div class="item">
                                <el-row style="border-bottom: #0478e4 2px solid">
                                  <el-col :span="24">
                                    <span style="font-size: 9px">{{ element.wujian_short_name }}&nbsp;-&nbsp;</span>
                                    <span style="font-size: 9px">{{ element.floor }}F&nbsp;-&nbsp;</span>
                                    <span style="font-size: 9px">{{ paint_type_name[element.paint_type]}}</span>
                                  </el-col>
                                </el-row>

                                <el-row :style="lineCnt.dayShiftCnt == 'powder' || lineCnt.dayShiftCnt == 'liquid' ||  lineCnt.nightShiftCnt == 'powder' || lineCnt.nightShiftCnt == 'liquid'?'border-bottom: #0478e4 2px solid':''">
                                  <el-col v-for="batchNo in element.batchData" :key="batchNo" :span="12">
                                    <div style="font-size: 10px">{{ batchNo }}</div>
                                  </el-col>
                                </el-row>
                                <el-row v-if="lineCnt.dayShiftCnt == 'powder' || lineCnt.dayShiftCnt == 'liquid' ||  lineCnt.nightShiftCnt == 'powder' || lineCnt.nightShiftCnt == 'liquid'">
                                  <el-col v-for="color in element.colorData" :key="color" :span="12">
                                    <div style="font-size: 10px">{{ color }}</div>
                                  </el-col>
                                </el-row>
                              </div>
                            </template>
                          </draggable>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="size" style="height: 35%;border:none">
            <el-row style="width: 100%;height: 100%;margin-top: 10px">
              <div style="width: 50%;height: 100%;">
                <div  v-loading="QCLOutputLoading" element-loading-text="数据加载中"
                     style="width: 100%;height: 100%;" id="QCLOutput"/>
              </div>
              <div style="width: 50%;height: 100%;">
                <div  v-loading="PTOutputLoading" element-loading-text="数据加载中"
                     style="width: 100%;height:100%;" id="PTOutput"/>
              </div>

            </el-row>
        </div>

      </div>

    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import { useDateFormat } from '@vueuse/core';
import moment from "moment/moment";
import draggable from "vuedraggable";
export default {
  name: "TZSiteHomePage",
  components: {draggable},
  data(){
    return {
      totalTime:null,
      timer: null,
      currentTime: '',
      //涂装生产数据
      tzProductionData:{
        worker_num:0,
        pretreatment_area:0,
        spray_area:0,
      },
      scheduleTableData:[],
      scheduleTableDataAll:[],
      scheduleTableIndex: 0, // 当前显示的数据在allData中的起始索引
      scheduleTableIntervalId: null, // 存储定时器的ID
      //前处理
      QCLData: {
        day: this.getDateFormat(),
        wuJianId: '',
        tableName: 'mfg_pretreatment_plan_actual'
      },
      //前处理生产生产实绩
      QCLOutput: {
        title: [
          {
            text: '涂装前处理生产实绩',
            left: '50%',
            textAlign: 'center'
          },],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          bottom:35,
          data: ['计划','实绩','累计计划','累计实绩']
        },
        grid: {
          left: '8%',
          right: '8%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            axisTick: {
              show: false
            },
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value',
            name:'面积(㎡)',
            axisLabel: {
              formatter: function (value){
                return Math.ceil(value).toLocaleString()
              }
            }
          },
          {
            type: 'value',
            name:'累計面积(㎡)',
            axisLabel: {
              formatter: function (value){
                return Math.ceil(value).toLocaleString()
              }
            }
          }
        ],
        series: [
          {
            name: '计划',
            type: 'bar',
            label: {
              position: 'inside'
            },
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '实绩',
            type: 'bar',
            label: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '累计计划',
            type: 'line',
            color:'#fac858',
            label: {},
            yAxisIndex: 1,
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '累计实绩',
            type: 'line',
            color:'#ee6666',
            yAxisIndex: 1,
            label: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          }
        ]
      },
      QCLOutputLoading: false,
      //喷涂
      PTData: {
        day: this.getDateFormat(),
        wuJianId: '',
        tableName: 'mfg_spray_plan_actual'
      },
      //喷涂生产生产实绩
      PTOutput: {
        title: [
          {
            text: '涂装喷涂生产实绩',
            left: '50%',
            textAlign: 'center'
          },],
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          bottom: 35,
          data: ['计划','实绩','累计计划','累计实绩']
        },
        grid: {
          left: '8%',
          right: '8%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            axisTick: {
              show: false
            },
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value',
            name:'面积(㎡)',
            axisLabel: {
              formatter: function (value){
                return Math.ceil(value).toLocaleString()
              }
            }
          },
          {
            type: 'value',
            name:'累計面积(㎡)',
            axisLabel: {
              formatter: function (value){
                return Math.ceil(value).toLocaleString()
              }
            }
          }
        ],
        series: [
          {
            name: '计划',
            type: 'bar',
            label: {
              position: 'inside'
            },
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '实绩',
            type: 'bar',
            label: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '累计计划',
            type: 'line',
            color:'#fac858',
            label: {},
            yAxisIndex: 1,
            emphasis: {
              focus: 'series'
            },
            data: []
          },
          {
            name: '累计实绩',
            type: 'line',
            color:'#ee6666',
            yAxisIndex: 1,
            label: {},
            emphasis: {
              focus: 'series'
            },
            data: []
          }
        ]
      },
      PTOutputLoading: false,
      showPage:'QCL',

      //////////涂装排产
      intervalId: null, // 存储定时器ID
      timePC1:null,
      timePC2:null,
      startDate: '',
      endDate: '',
      assemblyEndTime: '',
      state:{
        dataList:[],
      },
      tzWeek: [], //时间组件数据
      weekList: [], //一个星期的时间
      lineBool:false,//false表示白班 true表示夜班
      loading:false,
      maxHeight:"",//获取页面的最大高度
      paint_type_name:{
        'ft': '粉体',
        'fs': '液体',
        'acl': '共通'
      },
      gGrade:[],
      zGrade:[],
      cGrade:[],
      tzScrollId: null, // 滚动定时器的ID
      ///
      scrollDirection: ['right','right','right','right','right','right','right','right'],
      isScroll: ['right','right','right','right','right','right','right','right'],
      userLoading:false
    }

  },
  methods: {
    /*判断字符串数组里的每一项是否相同*/
    isAllSame(arr) {
      if (arr.length === 0) {
        return true;
      }
      const firstItem = arr[0];
      return arr.every(item => item === firstItem);
    },

    startAutoScroll() {
      if (this.tzScrollId) {
        // 如果已经在滚动，则不再执行
        return;
      }
      this.tzScrollId = setInterval(() => {
        const containers = this.$el.querySelectorAll('.scroll-container');
        if (containers) {
          containers.forEach((container, index) => {
            if (this.scrollDirection[index] === 'right') {
              container.scrollLeft += 1;
              if (Math.ceil(container.scrollLeft) >= container.scrollWidth - container.clientWidth) {
                this.isScroll[index] = 'left'
                if (this.isAllSame(this.isScroll)) {
                  setTimeout(() => {
                    this.scrollDirection[index] = 'left';
                  }, 3000)
                }
              }
            } else {
              container.scrollLeft -= 1;
              if (container.scrollLeft === 0) {
                this.isScroll[index] = 'right'
                if (this.isAllSame(this.isScroll)) {
                  setTimeout(() => {
                    this.scrollDirection[index] = 'right';
                  }, 3000)
                }
              }
            }
          })
        }
      }, 50); // 每0.01秒滚动一次
    },
    stopAutoScroll() {
      if (this.tzScrollId) {
        clearInterval(this.tzScrollId);
        this.tzScrollId = null;
      }
    },
    getDateFormat(){
      let month = new Date().getMonth() + 1
      return new Date().getUTCFullYear().toString() + "-" + month.toString() + "-1"
    },
    renderEcharts(id,option){
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let chart = echarts.init(document.getElementById(id));
        chart.setOption(option)
        /*let time
        let _this = this
        //chart绑定滚动事件
        chart.on('dataZoom',function (params) {
          //滚动条事件添加防抖
          clearTimeout(time)
          time = setTimeout(()=>{
            _this.getWuJianChartData(params)
          },1000)
        })*/
      }
    },
    dateFormat(){
      this.currentTime = useDateFormat(new Date(), 'YYYY-MM-DD HH:mm:ss dddd')
    },
    //获取涂装生产概况
    getPaintingFromData() {
      this.$axios.post('mfg/paintingCalendar/getPaintingAreaData').then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error("获取数据失败" + res.message);
        }
        this.tzProductionData = res.data;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    //获取涂装生产进度
    getPaintingSchedule() {
      this.$axios.post('mfg/paintingCalendar/getPaintingSchedule').then(response => {
        let res = response.data
        if (res.code !== 0) {
          return this.$message.error("获取数据失败" + res.message);
        }
        this.scheduleTableDataAll = res.data;
        //初始4条
        this.scheduleTableData = this.scheduleTableDataAll.slice(this.scheduleTableIndex, this.scheduleTableIndex + 4);
        this.scheduleTableIndex = 4;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
      })
    },
    //每过10秒切换4条
    startDataRefresh() {
      this.stopDataRefresh(); // 确保只有一个定时器运行
      this.scheduleTableIntervalId = setInterval(() => {
        this.scheduleTableData = this.scheduleTableDataAll.slice(this.scheduleTableIndex, this.scheduleTableIndex + 4);
        this.scheduleTableIndex += 4;
        if (this.scheduleTableIndex >= this.scheduleTableDataAll.length) {
          this.scheduleTableIndex = 0; // 循环到数据末尾时重置索引
        }
      }, 10000); // 每10秒更新一次
    },
    stopDataRefresh() {
      clearInterval(this.scheduleTableIntervalId);
    },

    //前处理生产实绩
    async getQLCProduceActual() {

      if (!this.QCLData.day) {
        this.QCLData.day = this.getDateFormat()
      }
      this.QCLOutputLoading = true
      let {data: res} = await this.$axios.post('mfg/tuzhuangProduce/getProduceActual', this.QCLData);
      if (res.code !== 0) {
        this.$message.error(res.message)
      } else {
        this.QCLOutput.xAxis[0].data = res.data.xAxis
        this.QCLOutput.series[0].data = res.data.areaPlanList
        this.QCLOutput.series[1].data = res.data.areaActualList
        this.QCLOutput.series[2].data = res.data.accumulateAreaPlanList
        this.QCLOutput.series[3].data = res.data.accumulateAreaActualList

        let maxA = this.$common.getMaxValue(res.data.areaPlanList,res.data.areaActualList)
        let maxB = this.$common.getMaxValue(res.data.accumulateAreaPlanList,res.data.accumulateAreaActualList)

        this.QCLOutput.yAxis[0].max = Math.ceil(maxA/5)*6
        this.QCLOutput.yAxis[0].interval = Math.round(this.QCLOutput.yAxis[0].max / 5 * 100) / 100

        this.QCLOutput.yAxis[1].max = Math.ceil(maxB/5)*6
        this.QCLOutput.yAxis[1].interval = Math.round(this.QCLOutput.yAxis[1].max / 5 * 100) / 100
      }
      this.renderEcharts('QCLOutput', this.QCLOutput)
      this.QCLOutputLoading = false
    },
    //喷涂生产实绩
    async getPTProduceActual() {

      if (!this.PTData.day) {
        this.PTData.day = this.getDateFormat()
      }
      this.PTOutputLoading = true
      let {data: res} = await this.$axios.post('mfg/tuzhuangProduce/getProduceActual', this.PTData);
      if (res.code !== 0) {
        this.$message.error(res.message)
      } else {
        this.PTOutput.xAxis[0].data = res.data.xAxis
        this.PTOutput.series[0].data = res.data.areaPlanList
        this.PTOutput.series[1].data = res.data.areaActualList
        this.PTOutput.series[2].data = res.data.accumulateAreaPlanList
        this.PTOutput.series[3].data = res.data.accumulateAreaActualList

        let maxA = this.$common.getMaxValue(res.data.areaPlanList,res.data.areaActualList)
        let maxB = this.$common.getMaxValue(res.data.accumulateAreaPlanList,res.data.accumulateAreaActualList)

        this.PTOutput.yAxis[0].max = Math.ceil(maxA/5)*6
        this.PTOutput.yAxis[0].interval = Math.round(this.PTOutput.yAxis[0].max / 5 * 100) / 100

        this.PTOutput.yAxis[1].max = Math.ceil(maxB/5)*6
        this.PTOutput.yAxis[1].interval = Math.round(this.PTOutput.yAxis[1].max / 5 * 100) / 100
      }
      this.renderEcharts('PTOutput', this.PTOutput)
      this.PTOutputLoading = false
    },
    ////////////////////////涂装排产
    async getCalendarLineDataAll(startTime, endTime, weekList) {
      this.loading = true;
      let params = {startTime:startTime, endTime:endTime, weekList:weekList}
       this.$axios.post('mfg/paintingProduction/getCalendarLineDataAll', params).then(response => {
        let res = response.data
        if (res.code !== 0){
          this.loading = false;
          return this.$message.error(res.message);
        }
        this.state.dataList = res.data;
         setTimeout(() => {
           this.getMaxHeight();
           this.scrollToBottom();
         }, 200);
        this.loading = false;
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
        this.loading = false;
      })
    },
    // 获取
    getCurrWeekDays() {
      let obj = {
        startTime: '',
        endTime: ''
      }

      obj.startTime = moment().format('YYYY-MM-DD');
      obj.endTime = moment(obj.startTime).add(6,'days').format('YYYY-MM-DD');
      return obj
    },
    //处理时间
    async formatTime(startTime, endTime) {
      this.tzWeek = [];
      this.weekList = [];
      let startDate = moment(startTime).add(-1,'days');
      let endDate = moment(endTime);
      let weeks = ["日","一","二","三","四","五","六"]
      while (startDate.isBefore(endDate)) {
        startDate.add(1,'days');
        let date = moment(startDate).format('YYYY-MM-DD')
        let item = {};
        item.time = moment(date).format('MM') + "月" + moment(date).format('DD') + "日";
        item.week = "(" + weeks[moment(date).day()] + ")";
        this.weekList.push(item);
      }
      this.startDate = moment(startTime).format('MM') + "-" + moment(startTime).format('DD');
      this.endDate = moment(endTime).format('MM') + "-" + moment(endTime).format('DD');
      this.tzWeek.push(this.startDate);
      this.tzWeek.push(this.endDate);
      await this.getCalendarLineDataAll(startTime, endTime, this.weekList)
    },
    async getAssemblyEndTime(){
      let startTime = moment(moment().week(moment().week()).startOf('week').add(1, 'days').valueOf()).format('YYYY-MM-DD');
      let endTime = moment(moment().week(moment().week()).endOf('week').add(8, 'days').valueOf()).format('YYYY-MM-DD');
      let params = {startTime: startTime, endTime: endTime};
      this.$axios.post('mfg/paintingProduction/getAssemblyEndTime',params).then(response => {
        let res = response.data
        if (res.code !== 0){
          return this.$message.error("组立最后排产时间为空");
        }

        this.assemblyEndTime = res.data;
        let obj = this.getCurrWeekDays();
        this.formatTime(obj.startTime,obj.endTime);
      }, error => {
        this.$message.error(`页面数据加载失败` + error.message);
        this.loading = false;
      })
    },
    getMaxHeight() {
      var h_max = 0;
      var widthBox = document.getElementsByClassName('data_style');
      for (var i = 0; i < widthBox.length; i++) {
        if (h_max < widthBox[i].clientHeight) {
          h_max = widthBox[i].clientHeight;
        }
      }

      let totalHeight = this.$refs.total_height.clientHeight;
      let timeHeight = totalHeight * 0.06;
      let pageHeight = totalHeight - timeHeight - 15;
      if (h_max < pageHeight) {
        h_max = pageHeight;
      }

      this.maxHeight = "height: "+(h_max - 10)+"px;";
    },
    async getUserSkillGrade() {
      this.userLoading = true
      let {data:res} = await this.$axios.post('train/trainUser/getUserSkillGrade',"6388643f7dd623e881e6a4a3")
      res.data.forEach((item)=>{

        if (item.grade.includes("高")){
          this.gGrade.push(item)
        }
        if (item.grade.includes("中")){
          this.zGrade.push(item)
        }
        if (item.grade.includes("初")){
          this.cGrade.push(item)
        }
      })
      this.userLoading = false
    },
    async scrollToBottom() {
      let isAutoScrolling = true;
      if (this.intervalId) {
        // 如果已经在滚动，则不再执行
        return;
      }
      const height = this.$refs.dynamicDiv.scrollHeight - this.$refs.dynamicDiv.offsetHeight;
      let cnt = -60;
      this.intervalId = setInterval(() => {
        const container = this.$el.querySelector('.scrollable-container');
        if (container && isAutoScrolling) {
          cnt += 1; // 每次滚动1px
        }

        if (container && isAutoScrolling && cnt >= 0) {
          container.scrollTop += 1; // 每次滚动1px
        }

        if (container.scrollTop >= height && isAutoScrolling) {
          setTimeout(() => {
            container.scrollTop = 0;
            cnt = -60;
          }, 3500);
        }

      }, 70); // 每0.06秒滚动一次
      // 监听鼠标滚动事件，暂停自动滚动
      window.addEventListener('wheel', () => {
        isAutoScrolling = !isAutoScrolling;
      });

      // 监听鼠标移动事件，暂停自动滚动
      window.addEventListener('mousemove', () => {
        isAutoScrolling = !isAutoScrolling;
      });
    },
    stopToBottom() {
      clearInterval(this.intervalId)
      clearInterval(this.timePC1)
      clearInterval(this.timePC2)
    }
  },

  async created() {
    await this.getPaintingFromData()
    await this.getQLCProduceActual()
    await this.getPTProduceActual()
    await this.getPaintingSchedule()
    await this.getAssemblyEndTime();
    await this.getUserSkillGrade()
    await this.startDataRefresh()
  },

  mounted(){
    this.timer = setInterval(()=>{
      this.dateFormat();
    }, 1000)

    //页面所有数据刷新  30分钟
    this.totalTime = setInterval(()=>{
      this.getPaintingFromData()
      this.getPaintingSchedule()
      this.getAssemblyEndTime();
    }, 1800000)
    this.$nextTick(()=>{
      this.startAutoScroll(); // 组件挂载后开始自动滚动
    })
  },

  unmounted() {
    clearInterval(this.totalTime)
    clearInterval(this.timer)
    this.stopDataRefresh()
    this.stopToBottom(); // 组件销毁前停止自动滚动
    this.stopAutoScroll()

  },

}
</script>

<style scoped>

.pageContainer{
  display: flex;
  flex-direction: row;
  overflow: hidden;
  width: 100%;
  height: 100%;
}
.varchar_size{
  font-size: 35px;
  color: whitesmoke;
  font-weight: bold;
  margin-left: 10%;
}

.asideContainer{
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content:  flex-start;
  align-items: center;
}

.size{
  height: 40%;
  justify-content: center;
}

.title{
  border-left: 3px solid steelblue;
  height: 18px;
  width: 90%;
  padding-left: 5px;
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.summary{
  width: 95%;
  height: 70%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.messageCard{
  width: 110px;
  height: 70px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

margin-right{
  margin-right: 5px;
}

.message{
  font-size: 20px;
  color: whitesmoke;
  border-radius: 5px;
}

/*涂装排产*/
.border {
  border:rgb(216, 220, 230) 1px solid;
}

.color {
  background-color: #e7e7e7;
}

.center {
  text-align: center;
  line-height: 32px;
}

.cursor {
  cursor: pointer;
}

/*一下是拖拽样式*/
.item {
  border: solid 2px #0478e4 !important;
  font-size: 9px;
  color: black;
  margin-top: 3px;
  height: 100%;
  text-align: center;
  background-color: whitesmoke;
}

.chosenClass {
  font-size: 13px;
  font-weight: bold;
}

/*button样式*/
.button {
  color: white;
  border-radius: 5px 5px 0 0;
  width: 100%;
  margin-top: 5px;
}

/*div样式*/
.week {
  border: #909399 0 solid;background-color: white; color: rgb(4, 134, 254);
}

.total_style {
  align-items: center;
  margin-left: 3px;
}

.data_style {
  width: 100%;
  height: auto;
}

.data_style1 {
  width: 100%;
  height: auto;
  background-color: #e7e7e7;
  margin-top: 2px;
  border:rgb(216, 220, 230) 2px solid;
}

.data_style2 {
  width: 100%;
  margin-top: 2px;
  border:rgb(216, 220, 230) 2px solid;
}

.data_style3 {
  width:100%;
  background-color: rgb(228, 231, 237);
  color: white;
  text-align: center;
  height: 22px;
  line-height: 22px;
}

.data_style4 {
  background-color: #0478e4;
  font-size: 12px;
}

.data_style4_1 {
  background-color: black;
  margin-left: 2px;
  font-size: 12px;
}

.scrollbar::-webkit-scrollbar{
  display: none;
}

.prompt {
  color:rgba(0, 0, 0, 0.2);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.scrollable-container {
  overflow: auto;
  height: auto; /* 设置容器高度 */
}

.level1{
  width: 8%;
  height:100%;
  color: whitesmoke;
  display: flex;
  justify-content: center;
  align-items: center
}

.level2{
  border:solid whitesmoke;
  border-width: 2px 0 2px 0;
  width: 100%;
  display: flex;
  align-items: center;
}

.grade{
  width: 50px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 2px whitesmoke solid;
}

.level1-right{
  width: 90%;
  display: flex;
  flex-direction: column
}

.userCard{
  width: 120px;
  height: 100%;
  display: flex;
}

.sizeUser{
  font-size: 0.9vh;
  height: 33%;
}

.border-right{
  border-right: 2px whitesmoke solid;
}

.border-left{
  border-left: 1px whitesmoke solid;
}

.border-bottom{
  border-bottom: 1px whitesmoke solid;
}

.border-top{
  border-top: 1px whitesmoke solid;
}

.align-center{
  display: flex;
  justify-content: center;
  align-items: center;
}

.scroll-container {
  width: 100%;
  height: 100%;
  overflow-x: auto;
  white-space: nowrap;
  display: flex;
  -ms-overflow-style: none; /* IE 10+ */
  scrollbar-width: none; /* Firefox */
}

.scroll-content {
  display: flex;
  /* 添加你需要的样式 */
  /*animation: scroll 15s linear infinite; !* 设置动画 *!*/
}

@keyframes scroll {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(0); }
}

/* 滚动条的样式 */
.scroll-container::-webkit-scrollbar {
  display: none;
}

/* 隐藏滚动条 */
::-webkit-scrollbar {
  width: 0;
  background: transparent; /* 使滚动条透明 */
}

</style>